export default {
  cart: [],
  buyer: [],
  order: [],

};
